/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Button, CircularProgress } from '@material-ui/core'

import Actions from '../../../fluid/Actions/ActionFactory'
import FlexForm from '../../FlexForm/FlexForm'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    
})

let form = [
    {
    name: "Email Event",
    value: {
      number: null,
      text: null,
      list: null,
      boolean: null
    },
    elements: null,
    component: "event",
    component_params: []
  }
]

class SubscribeEvents extends Component {
    state = {
        form : null,
        subscribing : false,
        error_message : null
    }

    componentWillMount () {
        this.setState({
            ...this.state,
            form : form
        })
    }

    heading = React.createRef()
    footer = React.createRef()

    componentDidMount () {
        const headingHeight = this.heading.current.clientHeight
        const footerHeight = this.footer.current.clientHeight
        const contentHeight = this.props.maxHeight - headingHeight - footerHeight

        this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight})
    }

    updateForm = (form) => {
        this.setState({...this.state, form: form}, () => console.log('State : ', this.state))
    }

    renderForm = () => {
        return (
            <FlexForm config = {this.state.form} fields_in_scope = {[]} update_parent = {(form) => this.updateForm(form)} submit = {(form) =>  this.setAccessDetails(form)}/>
        )
    }

    subscribeEvents = () => {
        this.setState({
            ...this.state,
            subscribing : true
        }, () => {
            Actions("http_request", {
                url: "/sainapse/workflow/subscribe",
                method : "post",
                data : {
                    event_name : this.state.form[0].value.text,
                    workflow_name : this.props.wf_name
                }
            }).then(res => {
                this.setState({
                    ...this.state,
                    subscribing : false,
                    error_message : null
                }, () => this.props.handleNext())
            }).catch(err => {
                this.setState({
                    ...this.state,
                    subscribing : false,
                    error_message : "Error subscribing to event."
                })
            })
        })
    }

    render() {
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper elevation = {0} square style = {{width : '100%', height : this.props.maxHeight + 'px', overflow : 'scroll'}}>
                    <div ref = {this.heading} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row', 
                            alignItems : 'center',
                            alignContent : 'flex-end',
                            backgroundColor : '#F0F0F0',
                            borderBottom : '1px solid rgba(0,0,0,0.12)',
                            padding : '8px'
                        }}>
                        <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography variant='h6' style ={{fontWeight : 800}}>Add Scripts</Typography>
                            <Typography style = {{marginleft: '10px', color : '#F50157'}} variant = 'caption'>{this.state.error_message}</Typography>
                        </div>
                        <Button variant = 'contained' size = 'small' color = 'primary' onClick = {() => this.props.handleNext()}>Skip</Button>
                    </div>
                    <div 
                        style = {{
                            width : '100%',
                            height: this.state.content_height,
                            maxHeight : this.state.content_height,
                            overflow: 'scroll'
                        }}
                    >
                        {this.renderForm()}
                    </div>
                    <div ref = {this.footer} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row-reverse',
                            backgroundColor : '#F0F0F0',
                            padding : '8px',
                            borderTop : '1px solid rgba(0,0,0,0.12)',
                        }}>
                        <Button
                            variant = 'contained'
                            color = 'primary'
                            size = 'small'
                            startIcon = {this.state.submitting_iu_maps ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                            onClick = {this.subscribeEvents}
                            disabled = { this.state.error_message !== null }
                        >
                            Submit
                        </Button>
                    </div>
                </Paper>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(SubscribeEvents);